/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 7V14.5C10 15.8807 11.1193 17 12.5 17V17C13.8807 17 15 15.8807 15 14.5V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 5V14.5C20 18.6421 16.6421 22 12.5 22V22C8.35786 22 5 18.6421 5 14.5L5 7C5 4.23858 7.23858 2 10 2V2C12.7614 2 15 4.23858 15 7V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M20 5V14.5C20 18.6421 16.6421 22 12.5 22V22C8.35786 22 5 18.6421 5 14.5L5 7C5 4.23858 7.23858 2 10 2V2C12.7614 2 15 4.23858 15 7V14.5C15 15.8807 13.8807 17 12.5 17V17C11.1193 17 10 15.8807 10 14.5V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M20 5V14.5C20 18.6421 16.6421 22 12.5 22V22C8.35786 22 5 18.6421 5 14.5L5 7C5 4.23858 7.23858 2 10 2V2C12.7614 2 15 4.23858 15 7V14.5C15 15.8807 13.8807 17 12.5 17V17C11.1193 17 10 15.8807 10 14.5V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M20 5V14.5C20 18.6421 16.6421 22 12.5 22V22C8.35786 22 5 18.6421 5 14.5V12.5V12M10 7V14.5C10 15.8807 11.1193 17 12.5 17V17C13.8807 17 15 15.8807 15 14.5V7C15 4.23858 12.7614 2 10 2V2C7.23858 2 5 4.23858 5 7V7.5V8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M20 5V14.5C20 18.6421 16.6421 22 12.5 22V22C8.35786 22 5 18.6421 5 14.5L5 7C5 4.23858 7.23858 2 10 2V2C12.7614 2 15 4.23858 15 7V14.5C15 15.8807 13.8807 17 12.5 17V17C11.1193 17 10 15.8807 10 14.5V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M20 5V14.5C20 18.6421 16.6421 22 12.5 22V22C8.35786 22 5 18.6421 5 14.5L5 7C5 4.23858 7.23858 2 10 2V2C12.7614 2 15 4.23858 15 7V14.5C15 15.8807 13.8807 17 12.5 17V17C11.1193 17 10 15.8807 10 14.5V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
